function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.576 9.41l9.08 9.08c.4.4.4 1.03 0 1.41l-2.3 2.3a.996.996 0 0 1-1.41 0l-9.11-9.11c-2.32.87-5.03.38-6.89-1.48-2.3-2.29-2.51-5.88-.65-8.42l3.83 3.83 1.42-1.41-3.84-3.85c2.55-1.86 6.13-1.65 8.43.65a6.505 6.505 0 0 1 1.44 7zm-3.38 1.22l9.46 9.46.88-.89-9.45-9.45c.46-.59.76-1.25.88-1.96.25-1.39-.16-2.88-1.24-3.96-.95-.94-2.2-1.38-3.44-1.31l3.09 3.09-4.24 4.24-3.09-3.09c-.07 1.24.37 2.5 1.32 3.44a4.472 4.472 0 0 0 3.83 1.25c.71-.1 1.39-.37 2-.82z",
  fill: "#323C47"
});

var SvgTool = function SvgTool(props) {
  return React.createElement("svg", _extends({
    width: 22,
    height: 23,
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/tool.9d9341e9.svg";
export { SvgTool as ReactComponent };